import { CSSProperties, MouseEvent, ReactNode } from 'react'

export enum SurfaceType {
  Dialog = 'dialog',
  Menu = 'menu',
  Listbox = 'listbox',
  Tree = 'tree',
  Grid = 'grid',
}

export type AreaProps = {
  id: string
  'aria-haspopup': SurfaceType
  'aria-expanded': boolean
  'aria-controls': string
}

export enum SurfacePlacement {
  Bottom = 'bottom',
  CursorTopRight = 'cursor-top-right',
}

export type Props = {
  children: (onClick: () => void, opened: boolean, areaProps: AreaProps) => ReactNode

  className?: string
  surfaceContentClassName?: string

  id: string

  type: SurfaceType

  surfaceContent: (
    toggle: (event?: MouseEvent<HTMLElement>) => void, // !!! Если не передать event CursorTopRight не будет работать
    opened: boolean,
    updatePosition: () => void,
  ) => ReactNode

  ariaLabelledby?: string
  ariaDescribedby?: string

  onOpenState?: (state: boolean) => void

  placement?: SurfacePlacement
}

export type Placement = 'top' | 'bottom'

export type DropdownPosition = {
  placement: Placement
  style: CSSProperties
}
